import { useCallback, useMemo } from "react"

import { useSearch, useLocation } from "wouter"

import { LENGTH_SEARCH_PARAM_NAME } from "@/config"

import { parseBookingLengthParam } from "../../schemas/urlParamSchemas"

const useBookingLengthParam = () => {
  const search = useSearch()
  const [location, navigate] = useLocation()

  const bookingLengthId = useMemo(() => {
    const params = new URLSearchParams(search)
    const rawLength = params.get(LENGTH_SEARCH_PARAM_NAME)
    return parseBookingLengthParam(rawLength)
  }, [search])

  const setBookingLength = useCallback(
    (id: string, { replace = false }: { replace?: boolean } = {}) => {
      const params = new URLSearchParams(search)
      params.set(LENGTH_SEARCH_PARAM_NAME, id)
      navigate(`${location}?${params.toString()}`, { replace })
    },
    [search, location, navigate]
  )

  const clearBookingLength = useCallback(() => {
    const params = new URLSearchParams(search)
    params.delete(LENGTH_SEARCH_PARAM_NAME)
    const query = params.toString()
    navigate(query ? `${location}?${query}` : location, { replace: true })
  }, [search, location, navigate])

  return { bookingLengthId, setBookingLength, clearBookingLength }
}

export default useBookingLengthParam
